import ButtonMinSizeRule from './Single/ButtonMinSizeRule';
import ButtonTextLengthRule from './Single/ButtonTextLengthRule';
import ContrastRule from './Single/ContrastRule';
import MissingButtonLink from './Single/MissingButtonLink';
import InputFieldNameRule from './Single/InputFieldNameRule';
import TextSizeRule from './Single/TextSizeRule';
import CountdownTimerHourRule from './Single/CountdownTimerHourRule';
import TitleTooLongRule from './Single/TitleTooLongRule';
import FormLinkRule from './Single/FormLinkRule';
import MissingMediaLinkRule from './Single/MissingMediaLinkRule';
import MissingVideoBgLinkRule from './Single/MissingVideoBgLinkRule';
import MissingPopupLinkRule from './Single/MissingPopupLinkRule';
import NoCallToActionFoundRule from './Group/NoCallToActionFoundRule';
import PageHightIsTooLongRule from './Group/PageHightIsTooLongRule';
import WeakSenseOfTrustRule from './Group/WeakSenseOfTrustRule';
import DifferentHeadingFontFamily from './Group/DifferentHeadingFontFamily';
import DifferentButtonFontFamily from './Group/DifferentButtonFontFamily';
import WeakSEO from './Group/WeakSEO';
import MissingLazyLoading from './Group/MissingLazyLoading';

export default {
  ButtonMinSizeRule,
  ContrastRule,
  MissingButtonLink,
  InputFieldNameRule,
  TextSizeRule,
  ButtonTextLengthRule,
  CountdownTimerHourRule,
  TitleTooLongRule,
  FormLinkRule,
  MissingMediaLinkRule,
  MissingVideoBgLinkRule,
  MissingPopupLinkRule,
  NoCallToActionFoundRule,
  PageHightIsTooLongRule,
  WeakSenseOfTrustRule,
  DifferentHeadingFontFamily,
  DifferentButtonFontFamily,
  WeakSEO,
  MissingLazyLoading,
};
